import { makeStyles, Tooltip, useTheme } from "@material-ui/core";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@material-ui/lab";
import { setOpenAnalysisForm } from "store/appSlice";
import { ANALYSIS_KEYS } from "data/models/AnalysisModel";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as IconAnalysis } from "assets/icons/icon-analysis.svg";
import { ReactComponent as IconDropapin } from "assets/icons/icon-analysis-dropapin.svg";

import CloseIcon from "@material-ui/icons/Close";
import { FEATURES, useFeature } from "hooks/useFeature";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  speedDialIcon: {
    "& svg": {
      fill: theme.palette.secondary?.contrastText,
    },
  },
}));

export default function AnalysisFloatingMenu() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const classes = useStyles();
  const overlayFormKey = useSelector((state) => state.app.openAnalysisForm);
  const [open, setOpen] = useState(false);

  function handleOverlayOpen(key) {
    setOpen(false);
    dispatch(setOpenAnalysisForm(key));
  }

  useEffect(() => {
    return () => dispatch(setOpenAnalysisForm(null));
  }, [dispatch]);

  const ANALYSIS_ACTIONS = [
    ...(useFeature(FEATURES.ANALYSIS_DAP)
      ? [
          {
            key: ANALYSIS_KEYS.DROPAPIN,
            name: "Select point",
            Icon: IconDropapin,
          },
        ]
      : []),
  ];

  return (
    ANALYSIS_ACTIONS.length && (
      <SpeedDial
        hidden={!!overlayFormKey}
        FabProps={{ color: "secondary" }}
        open={open}
        onClick={() => setOpen(!open)}
        className={classes.container}
        ariaLabel="Launch new analysis"
        direction="down"
        icon={
          <Tooltip title="Launch analysis" placement="left" arrow>
            <SpeedDialIcon
              className={classes.speedDialIcon}
              icon={<IconAnalysis />}
              open={open}
              openIcon={<CloseIcon />}
            />
          </Tooltip>
        }
      >
        {ANALYSIS_ACTIONS.map((a) => (
          <SpeedDialAction
            key={a.key}
            FabProps={{ disabled: a.disabled }}
            icon={<a.Icon style={{ color: theme.palette.grey[700] }} />}
            tooltipTitle={a.name}
            onClick={() => handleOverlayOpen(a.key)}
          />
        ))}
      </SpeedDial>
    )
  );
}
